import { Button } from '@mui/material';
import {
  DashboardHeaderSection,
  StyledActivityCardBackground
} from 'modules';


import {
  Outlet,
  useLocation,
  useNavigate
} from 'react-router-dom';



export type ProjectDashboardActivityProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const ProjectDashboardActivity = (props: ProjectDashboardActivityProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  if (location.pathname.includes('milestones')) {
    return (
      <Outlet />
    );
  }


  return (
    <StyledActivityCardBackground.FC>
      <Button
        variant='contained'
        onClick={() => {
          navigate('milestones');
        }}
      >
        View milestones
      </Button>

      <DashboardHeaderSection.FC />

    </StyledActivityCardBackground.FC>
  );
};
